/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    EditUserData: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.EditUserdataAction.REQUEST_EDITUSERDATA:
      return {
        ...state
      };
    case actions.EditUserdataAction.EDITUSERDATA_RECEIVED:
      return {
        ...state,
        EditUserData: action.data
      };

    default:
      return state;
  }
};

export default reducer;
